import React, { useState } from 'react';
import { ICreateInvoiceData, ItemInput } from '../@types';

export type InvoiceErrors = {
  [P in keyof ICreateInvoiceData]?: string;
// } & { inventories?: string };
} & { inventories?: string } & { [key: string]: string | undefined };


export const validateInvoiceBasicInfo = (
  formData: ICreateInvoiceData,
  setValidationResults: React.Dispatch<React.SetStateAction<InvoiceErrors>>,
): boolean => {
  let isError = false;
  const errors: InvoiceErrors = {};

  const validateField = (field: keyof ICreateInvoiceData, message: string) => {
    if (!formData[field]) {
      errors[field] = message;
      isError = true;
    } else {
      delete errors[field];
    }
  };

  validateField('customerId', 'Select a Customer');
  validateField('issueDate', 'Issue Date is required');
  validateField('invoiceDueAt', 'Due Date is required');
  validateField('currency', 'Currency is required');


  const issueDate = formData.issueDate ? new Date(formData.issueDate) : null;
  const dueDate = formData.invoiceDueAt ? new Date(formData.invoiceDueAt) : null;

  if (issueDate && dueDate) {
    if (dueDate < issueDate) {
      errors.invoiceDueAt = 'Due Date cannot be less than the Issue Date';
      isError = true;
    } else {
      delete errors.invoiceDueAt;
    }
  }

  setValidationResults(errors as InvoiceErrors);
  return !isError;
};

export const validateInvoiceItemDetails = (
  formData: ICreateInvoiceData,
  setValidationResults: React.Dispatch<React.SetStateAction<InvoiceErrors>>,
): boolean => {
  let isError = false;
  const errors: InvoiceErrors = {};

  if (!formData.inventories || formData.inventories.length === 0 || !formData.inventories[0].id) {
    errors.inventories = 'Add at least one inventory';
    isError = true;
  } else {
    formData.inventories.forEach((item: ItemInput, index: number) => {
      ['id', 'rate', 'quantity'].forEach((field) => {
        if (!item[field]) {
          errors.inventories += ` Inventory ${index + 1} is missing ${field}.`;
          isError = true;
        }
      });
      if (item.quantity !== undefined && item.quantity === 0) {
        errors.inventories += ` Inventory ${index + 1} quantity should be greater than zero.`;
        isError = true;
      }
    });
  }

  setValidationResults(errors as InvoiceErrors);
  return !isError;
};


export const validateInvoiceSummary = (
  formData: ICreateInvoiceData,
  setValidationResults: React.Dispatch<React.SetStateAction<InvoiceErrors>>,
): boolean => {
  let isError = false;
  const errors: InvoiceErrors = {};

  const validateField = (field: keyof ICreateInvoiceData, message: string) => {
    if (!formData[field]) {
      errors[field] = message;
      isError = true;
    } else {
      delete errors[field];
    }
  };

  if (formData.isReoccurring) {
    validateField('reoccurringGroupName', 'Reoccurring Group Name is required');
    validateField('isReoccurringEndDate', 'Reoccurring End Date is required');
  }

 

  setValidationResults(errors as InvoiceErrors);
  return !isError;
};


